module.exports = __webpack_public_path__ + "img/6.2137b5d7.png";